import { en } from './translationValues/translations-en'

export const translations = {
  en,
}
